import { useTranslation } from 'react-i18next';

export const ServiceVariableTooltipUsername = () => {
  const { t: translate } = useTranslation();
  return (
    <>
      {String(translate('service_details_form_component.service_variable_tooltip_title_username'))}<br />
      {String(translate('service_details_form_component.service_variable_tooltip_format_username'))}<br />
      {String(translate('service_details_form_component.service_variable_tooltip_example_username'))}<br />
      {String(translate('service_details_form_component.service_variable_tooltip_azure_username'))}
    </>
  );
};
